<!-- =========================================================================================
  File Name: App.vue
  Description: Main vue file - APP
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
========================================================================================== -->


<template>
  <div id="app" :class="vueAppClasses">
    <router-view @setAppClasses="setAppClasses" />

     <!--Alert Modal-->
    	<vs-popup 
        color="danger"
        :title="alertModal.content.header"
        @accept="CloseModal('AlertModal')"
        @close="CloseModal('AlertModal')"
        accept-text="Close"
        button-cancel="none"
        :active="alertModal.show">
        <div class="con-exemple-prompt">
        <p>{{alertModal.content.body[0]}}</p>
        <br/>
        <vs-textarea v-if="alertModal.content.details != ''" class="mt-2" disabled v-model="alertModal.content.details" height="10rem"></vs-textarea>

        <vs-button color="danger" class="float-right" @click="CloseModal('AlertModal')">Close</vs-button>

        </div>
      </vs-popup>

     <!--File Upload Modal-->
    	<!-- <vs-popup 
        color="danger"
        :title="fileUploadModal.content.header"
        @accept="CloseModal('FileUploadModal')"
        @close="CloseModal('FileUploadModal')"
        accept-text="Close"
        button-cancel="none"
        :active="fileUploadModal.show"
      >
        <div class="con-exemple-prompt">
        <p>{{fileUploadModal.content.body[0]}}</p>
        <br/>
        <vs-textarea v-if="fileUploadModal.content.details != ''" class="mt-2" disabled v-model="fileUploadModal.content.details" height="10rem"></vs-textarea>

        <vs-button color="danger" class="float-right" @click="CloseModal('FileUploadModal')">Close</vs-button>

        </div>
      </vs-popup> -->

  </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'

export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.general.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  computed: {
    alertModal () {
      return this.$store.getters.GetAlertModal
    }
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      console.log("resize")
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    CloseModal (modalName) {
      this.$store.dispatch('ActionOpenCloseModal', {'modal':modalName, 'show':false}, {root:true})
    }
  },
  mounted () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    
  },
  async created () {

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>


<style lang="css">

input.vs-checkbox--input {
  opacity: 0 !important;
}
input:read-only.vs-checkbox--input {
  opacity: 0 !important;
}
input:read-only{
  opacity: .3;
}
.theme-dark .dark-mode-background{
  background: #1a203a !important;
}
.theme-dark .vs__search{
  background: none !important;
}
.theme-dark .v-select .vs__dropdown-toggle{
  background: #10163a !important;
}
.theme-dark .vs-con-textarea{
  background: #10163a !important;
}
.theme-dark .whiteTextInDarkMode{
  color: white !important;
}
.greyed-out {
  opacity: .5;
}
::-webkit-scrollbar {
  width: 10px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.input-switch.vs-switch--input {
  opacity: 0;
}

.flex-right{
  float:right;
  margin-left:auto;
}

</style>
